module.exports = __webpack_public_path__ + "img/points_calc_de_tyre_car_dealer.a6758fe3.png";